import { useActionData } from 'react-router'

import { ClearedErrorData } from './apiError'

export type ActionError = Partial<ClearedErrorData>

export const useActionError = (): ActionError | undefined => {
  return useActionData<ClearedErrorData>()
}
